import React from 'react';
import { useNavigate } from 'react-router-dom';
import StatutoryComplianceNotice from './component/StatutoryComplianceNotice';

interface DashboardProps {
  user: any;
  setUser: (user: any) => void;
}

const Dashboard: React.FC<DashboardProps> = ({ user }) => {
  const navigate = useNavigate();
  const displayName = user?.name || user?.userName || 'Valued Customer';

  return (
    <div className="user-dashboard-wrapper">
      {/* Quick Category Action Cards */}
      <section className="ud-featured-boxes container">
        <div className="ud-section-heading">
          <span className="ud-subtag">CELEBRATE WITH JOY</span>
          <h2 className="ud-title">Featured Collections & Special Offers</h2>
          <p className="ud-subtitle">
            {user ? `Welcome back, ${displayName}! ` : ''}Explore our handpicked festive specials crafted for memorable celebrations
          </p>
        </div>

        <div className="ud-feature-grid">
          <div 
            className="ud-feature-card ud-card-gradient-1" 
            onClick={() => navigate('/category')}
            role="button"
            tabIndex={0}
          >
            <div className="ud-card-icon-badge">✨</div>
            <div className="ud-feature-card-content">
              <h3>Sparklers & Anar</h3>
              <p>Color flowerpots, pencil sparklers, ground chakkars for family & kids</p>
              <span className="ud-card-link">Explore Collection &rarr;</span>
            </div>
          </div>

          <div 
            className="ud-feature-card ud-card-gradient-2" 
            onClick={() => navigate('/category')}
            role="button"
            tabIndex={0}
          >
            <div className="ud-card-icon-badge">🚀</div>
            <div className="ud-feature-card-content">
              <h3>Sky Shots & Repeater Cakes</h3>
              <p>Multi-color aerial shots, parachute rockets, and 12-to-240 shot cakes</p>
              <span className="ud-card-link">Explore Collection &rarr;</span>
            </div>
          </div>

          <div 
            className="ud-feature-card ud-card-gradient-3" 
            onClick={() => navigate('/category')}
            role="button"
            tabIndex={0}
          >
            <div className="ud-card-icon-badge">💥</div>
            <div className="ud-feature-card-content">
              <h3>Dhamaka Sound Crackers</h3>
              <p>Hydro bombs, classic atom bombs, and traditional garland lad crackers</p>
              <span className="ud-card-link">Explore Collection &rarr;</span>
            </div>
          </div>

          <div 
            className="ud-feature-card ud-card-gradient-4" 
            onClick={() => navigate('/category')}
            role="button"
            tabIndex={0}
          >
            <div className="ud-card-icon-badge">🎁</div>
            <div className="ud-feature-card-content">
              <h3>Family Combo Gift Boxes</h3>
              <p>Assorted wholesale value hampers packed with all favorite varieties</p>
              <span className="ud-card-link">Explore Collection &rarr;</span>
            </div>
          </div>
        </div>
      </section>

      {/* Safety Guidelines Banner */}
      <section className="ud-safety-section container">
        <div className="ud-safety-card">
          <div className="ud-safety-header">
            <span className="ud-safety-icon">🛡️</span>
            <div>
              <h3>Safety Guidelines for Safe Celebrations</h3>
              <p>Enjoy your festivities with these essential safety reminders</p>
            </div>
          </div>
          <div className="ud-safety-tips">
            <div className="ud-safety-tip">
              <span className="ud-tip-number">1</span>
              <div>
                <strong>Open Space Only</strong>
                <span>Always ignite fireworks in an open outdoor area away from dry grass or structures.</span>
              </div>
            </div>
            <div className="ud-safety-tip">
              <span className="ud-tip-number">2</span>
              <div>
                <strong>Water & Sand Bucket</strong>
                <span>Keep a bucket of water and sand readily accessible nearby for disposal.</span>
              </div>
            </div>
            <div className="ud-safety-tip">
              <span className="ud-tip-number">3</span>
              <div>
                <strong>Adult Supervision</strong>
                <span>Never allow young children to light firecrackers without adult supervision.</span>
              </div>
            </div>
            <div className="ud-safety-tip">
              <span className="ud-tip-number">4</span>
              <div>
                <strong>Never Relight Duds</strong>
                <span>If a cracker fails to ignite, wait 15 minutes and douse it with water.</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Statutory Compliance Notice (Supreme Court 2018 Order) */}
      <section className="container" style={{ margin: '20px auto 30px' }}>
        <StatutoryComplianceNotice 
          variant="checkout" 
          storeName="Jai Bhavani Fireworks" 
          phone="+91-7990696364" 
          whatsappNumber="917990696364" 
        />
      </section>

      {/* WhatsApp Help / Direct Ordering Banner */}
      <section className="ud-cta-section container">
        <div className="ud-cta-banner">
          <div className="ud-cta-content">
            <span className="ud-cta-tag">DIRECT ASSISTANCE</span>
            <h2>Need Custom Combo Packs or Bulk Event Inquiries?</h2>
            <p>Our fireworks experts are available on WhatsApp to help you choose the best cracker packages for your family, wedding, or community events.</p>
            <div className="ud-cta-actions">
              <a 
                href="https://wa.me/917990696364?text=Hello%20Jai%20Bhavani%20Fireworks,%20I%20want%20to%20place%20a%20bulk%20order" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="ud-wa-btn"
              >
                💬 Chat on WhatsApp (+91 79906 96364)
              </a>
              <button className="ud-browse-btn" onClick={() => navigate('/category')}>
                Browse All Fireworks
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;